<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow class="waste-request-main">
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Filters</strong>
          </CCardHeader>
          <CCardBody>
            <div class="loader">
              <CSpinner
                style="
                  width: 5rem;
                  height: 5rem;
                  position: fixed;
                  top: 45%;
                  z-index: 999999;
                  display: none;
                "
                id="loader"
                color="info"
              />
            </div>
            <CTabs>
              <CTab title="Client Wise" active>
                <CForm
                  class="formData waste-form-main mt-4 pb-2 border-bottom-1"
                >
                  <CRow>
                    <CCol sm="3">
                      <CInput
                        label="From Date"
                        type="date"
                        :value="clientvise_fromdate_value"
                        id="clientvise_fromdate"
                        @input="dateFilter_client"
                      />
                      <!---
					  <label class="m-0 col-fonts-black">From Month</label>
					  <v-select
                        label="Select"
                        horizontal
                        :options="options"
                        placeholder="Please select"
                      ></v-select>-->
                    </CCol>
                    <CCol sm="3">
                      <CInput
                        label="To Date"
                        type="date"
                        :value="sitevise_todate_value"
                        id="clientvise_todate"
                        @input="dateFilter_client"
                      />
                      <!---
					  <label class="m-0 col-fonts-black">To Month</label>
					  <v-select
                        label="Select"
                        horizontal
                        :options="options"
                        placeholder="Please select"
                      ></v-select>--->
                    </CCol>
                    <CCol sm="3" class="mb-3">
                      <label class="m-0 col-fonts-black">Select Site</label>
                      <v-select
                        multiple
                        :options="siteOptions_client"
                        placeholder="Select Site"
                        @input="siteClientSel"
                      ></v-select>
                      <!---<v-select
                        label="Select"
                        horizontal
                        :options="options"
                        placeholder="Please select"
                      ></v-select>--->
                    </CCol>

                    <CCol sm="3" class="mb-3">
                      <label class="m-0 col-fonts-black">Select Client</label>
                      <v-select
                        multiple
                        :options="clientOptions"
                        placeholder="Select Client"
                        @input="ClientSel"
                      ></v-select>
                      <!--<v-select
                        label="Select"
                        horizontal
                        :options="options"
                        placeholder="Please select"
                      ></v-select>-->
                    </CCol>
                  </CRow>

                  <!--<CRow>
                    <CCol sm="6">
                      <button
                        aria-pressed="true"
                        type="button"
                        autocomplete="off"
                        class="btn btn-outline-light btn-block active fw-500 col-white fs-18 mb-2"
                      >
                        Cancel
                      </button>
                    </CCol>
                    <CCol sm="6">
                      <button
                        aria-pressed="true"
                        type="button"
                        autocomplete="off"
                        class="btn btn-outline-info btn-block active fw-500 col-white fs-18"
                      >
                        Submit
                      </button>
                    </CCol>
                  </CRow>-->
                </CForm>
                <CRow>
                  <CCol sm="3" class="mb-3">
                    <v-select
                      selected
                      :options="client_chart_option"
                      placeholder="Change Chart"
                      @input="client_change_chart"
                    ></v-select>
                  </CCol>
                </CRow>
                <CRow class="mt-4 m-0 pb-2 border-bottom-1">
                  <CCol sm="6" id="client_budget_pie">
                    <!---<span class="h6 text-center d-block">RSPL - Dahej</span>--->
                    <CChartDoughnut
                      :datasets="defaultDatasets_client"
                      :labels="['Excellent', 'Average', 'Poor']"
                    />

                    <CRow class="mt-2">
                      <CCol sm="4">
                        <span class="text-center d-block">Budget</span>
                        <span class="h6 text-center d-block col-black">{{
                          client_budget
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block">Received</span>
                        <span class="h6 text-center d-block col-black">{{
                          client_Received
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block col-red"
                          >O/S Amount</span
                        >
                        <span class="h6 text-center d-block col-red">{{
                          client_O_S_amount
                        }}</span>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol sm="6" id="client_revenue_pie" style="display: none">
                    <!---<span class="h6 text-center d-block">RSPL - Dahej</span>--->
                    <CChartDoughnut
                      :datasets="defaultDatasets_client_revanue"
                      :labels="['Excellent', 'Average', 'Poor']"
                    />

                    <CRow class="mt-2">
                      <CCol sm="4">
                        <span class="text-center d-block">Budget</span>
                        <span class="h6 text-center d-block col-black">{{
                          client_budget_revenue
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block">Received</span>
                        <span class="h6 text-center d-block col-black">{{
                          client_Received_revenue
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block col-red"
                          >O/S Amount</span
                        >
                        <span class="h6 text-center d-block col-red">{{
                          client_O_S_amount_revenue
                        }}</span>
                      </CCol>
                    </CRow>
                  </CCol>

                  <CCol sm="6" id="client_budget_collumn">
                    <CChartBar
                      :datasets="defaultDatasetsLine_client"
                      :labels="['SOLID', 'SEMI SOLID', 'LIQUID', 'AQUASQES']"
                    />
                  </CCol>
                  <CCol
                    sm="6"
                    id="client_revenue_collumn"
                    style="display: none"
                  >
                    <CChartBar
                      :datasets="defaultDatasetsLine_client_revenue"
                      :labels="['SOLID', 'SEMI SOLID', 'LIQUID', 'AQUASQES']"
                    />
                  </CCol>
                </CRow>

                <CRow class="marketing-dashboard-details">
                  <CCol
                    sm="6"
                    class="for-outer mt-3"
                    v-for="(clientRow, index) in client_list_data"
                    :key="index"
                  >
                    <div
                      class="marketing-dashboard-details-inner"
                      :Budget_Qty="clientRow.Budget_Qty"
                      :Budget_Revenue="clientRow.Budget_Revenue"
                      :Actual_Qty="clientRow.Actual_Qty"
                      :Actual_Revenue="clientRow.Actual_Revenue"
                      :Out_Standing_Amount="clientRow.Out_Standing_Amount"
                      :Physical_Status="clientRow.Physical_Status"
                      @click="rowset_client"
                    >
                      <CCol>
                        <span class="title col-black fw-500">Site</span>
                        <span class="col-black fw-500">Budget(Q)</span>
                        <span class="col-black fw-500">Budget(V)</span>
                      </CCol>
                      <CCol>
                        <span class="title">{{ clientRow.Plant_Name }}</span>
                        <span class="fw-500">{{ clientRow.Budget_Qty }}</span>
                        <span class="fw-500">{{
                          clientRow.Budget_Revenue
                        }}</span>
                      </CCol>
                      <CCol>
                        <span class="title"><pre></pre></span>
                        <span
                          class="fw-500 percentage"
                          v-if="
                            clientRow.Actual_Qty != '0.00' &&
                            clientRow.Budget_Qty != '0.00'
                          "
                          >{{
                            (clientRow.Actual_Qty / clientRow.Budget_Qty) * 100
                          }}%</span
                        >
                        <span class="fw-500 percentage" v-else>0%</span>
                        <span
                          class="fw-500 percentage"
                          v-if="
                            clientRow.Actual_Revenue != '0.00' &&
                            clientRow.Budget_Revenue != '0.00'
                          "
                          >{{
                            (clientRow.Actual_Revenue /
                              clientRow.Budget_Revenue) *
                            100
                          }}%</span
                        >
                        <span class="fw-500 percentage" v-else>0%</span>
                      </CCol>
                      <CCol>
                        <span class="title col-black fw-500">Site Code</span>
                        <span class="col-black fw-500">Actual(Q)</span>
                        <span class="col-black fw-500">Actual(V)</span>
                      </CCol>
                      <CCol>
                        <span class="title">{{ clientRow.Plant_Code }}</span>
                        <span class="fw-500">{{ clientRow.Actual_Qty }}</span>
                        <span class="fw-500">{{
                          clientRow.Actual_Revenue
                        }}</span>
                      </CCol>
                    </div>
                  </CCol>
                </CRow>
              </CTab>

              <CTab title="Site Wise">
                <CForm
                  class="formData waste-form-main mt-4 pb-2 border-bottom-1"
                >
                  <CRow>
                    <CCol sm="4">
                      <CInput
                        label="From Date"
                        type="date"
                        :value="sitevise_fromdate_value"
                        id="sitevise_fromdate"
                        @input="dateFilter_site"
                      />
                      <!---<label class="m-0 col-fonts-black">From Month</label>
                      <v-select
                        label="Select"
                        horizontal
                        :options="options"
                        placeholder="Please select"
                      ></v-select>-->
                    </CCol>
                    <CCol sm="4">
                      <CInput
                        label="To Date"
                        type="date"
                        :value="sitevise_todate_value"
                        id="sitevise_todate"
                        @input="dateFilter_site"
                      />
                      <!---<label class="m-0 col-fonts-black">To Month</label>
                      <v-select
                        label="Select"
                        horizontal
                        :options="options"
                        placeholder="Please select"
                      ></v-select>-->
                    </CCol>
                    <CCol sm="4" class="mb-4">
                      <label class="m-0 col-fonts-black">Select Site</label>
                      <v-select
                        multiple
                        :selected="siteOptions"
                        :options="siteOptions"
                        placeholder="Select Site"
                        @input="siteSel"
                      ></v-select>
                      <!---<v-select
                        label="Select"
                        horizontal
                        :options="options"
                        placeholder="Please select"
                      ></v-select>--->
                    </CCol>
                  </CRow>

                  <!--<CRow>
                    <CCol sm="6">
                      <button
                        aria-pressed="true"
                        type="button"
                        autocomplete="off"
                        class="btn btn-outline-light btn-block active fw-500 col-white fs-18 mb-2"
                      >
                        Cancel
                      </button>
                    </CCol>
                    <CCol sm="6">
                      <button
                        aria-pressed="true"
                        type="button"
                        autocomplete="off"
                        class="btn btn-outline-info btn-block active fw-500 col-white fs-18"
                      >
                        Submit
                      </button>
                    </CCol>
                  </CRow>-->
                </CForm>
                <CCol sm="3" class="mb-3">
                  <v-select
                    selected
                    :options="client_chart_option"
                    placeholder="Change Chart"
                    @input="site_change_chart"
                  ></v-select>
                </CCol>

                <CRow class="mt-4 m-0 pb-2 border-bottom-1">
                  <CCol sm="6" id="site_budget_pie">
                    <!---<span class="h6 text-center d-block">RSPL - Dahej</span>--->
                    <CChartDoughnut
                      :datasets="defaultDatasets_site"
                      :labels="['Excellent', 'Average', 'Poor']"
                    />

                    <CRow class="mt-2">
                      <CCol sm="4">
                        <span class="text-center d-block">Budget</span>
                        <span class="h6 text-center d-block col-black">{{
                          site_budget
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block">Received</span>
                        <span class="h6 text-center d-block col-black">{{
                          site_Received
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block col-red"
                          >O/S Amount</span
                        >
                        <span class="h6 text-center d-block col-red">{{
                          site_O_S_amount
                        }}</span>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol sm="6" id="site_revenue_pie" style="display: none">
                    <!---<span class="h6 text-center d-block">RSPL - Dahej</span>--->
                    <CChartDoughnut
                      :datasets="defaultDatasets_site_revanue"
                      :labels="['Excellent', 'Average', 'Poor']"
                    />

                    <CRow class="mt-2">
                      <CCol sm="4">
                        <span class="text-center d-block">Budget</span>
                        <span class="h6 text-center d-block col-black">{{
                          site_budget_revenue
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block">Received</span>
                        <span class="h6 text-center d-block col-black">{{
                          site_Received_revenue
                        }}</span>
                      </CCol>
                      <CCol sm="4">
                        <span class="text-center d-block col-red"
                          >O/S Amount</span
                        >
                        <span class="h6 text-center d-block col-red">{{
                          site_O_S_amount_revenue
                        }}</span>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol sm="6" id="site_budget_collumn">
                    <CChartBar
                      :datasets="defaultDatasetsLine_site"
                      :labels="['SOLID', 'SEMI SOLID', 'LIQUID', 'AQUASQES']"
                    />
                  </CCol>
                  <CCol sm="6" id="site_revenue_collumn" style="display: none">
                    <CChartBar
                      :datasets="defaultDatasetsLine_site_revenue"
                      :labels="['SOLID', 'SEMI SOLID', 'LIQUID', 'AQUASQES']"
                    />
                  </CCol>
                </CRow>

                <CRow class="marketing-dashboard-details">
                  <CCol
                    sm="6"
                    class="for-outer mt-3"
                    v-for="(siteRow, index) in site_list_data"
                    :key="index"
                  >
                    <div
                      class="marketing-dashboard-details-inner"
                      :Budget_Qty="siteRow.Plant_Budget_Qty_Sum"
                      :Budget_Revenue="siteRow.Plant_Budget_Revenue_Sum"
                      :Actual_Qty="siteRow.Plant_Actual_Qty_Sum"
                      :Actual_Revenue="siteRow.Plant_Actual_Revenue_Sum"
                      :Out_Standing_Amount="siteRow.Out_Standing_Amount"
                      :Physical_Status="siteRow.Physical_Status"
                      @click="rowset_site"
                    >
                      <CCol>
                        <span class="title col-black fw-500">Site</span>
                        <span class="col-black fw-500">Budget(Q)</span>
                        <span class="col-black fw-500">Budget(V)</span>
                      </CCol>
                      <CCol>
                        <span class="title">{{ siteRow.Plant_Name }}</span>
                        <span class="fw-500">{{
                          siteRow.Plant_Budget_Qty_Sum
                        }}</span>
                        <span class="fw-500">{{
                          siteRow.Plant_Budget_Revenue_Sum
                        }}</span>
                      </CCol>
                      <CCol>
                        <span class="title"><pre></pre></span>
                        <span
                          class="fw-500 percentage"
                          v-if="
                            siteRow.Plant_Actual_Qty_Sum != '0' &&
                            siteRow.Plant_Budget_Qty_Sum != '0'
                          "
                          >{{
                            (siteRow.Plant_Actual_Qty_Sum /
                              siteRow.Plant_Budget_Qty_Sum) *
                            100
                          }}%</span
                        >
                        <span class="fw-500 percentage" v-else>0%</span>
                        <span
                          class="fw-500 percentage"
                          v-if="
                            siteRow.Plant_Actual_Revenue_Sum != '0' &&
                            siteRow.Plant_Budget_Revenue_Sum != '0'
                          "
                          >{{
                            (siteRow.Plant_Actual_Revenue_Sum /
                              siteRow.Plant_Budget_Revenue_Sum) *
                            100
                          }}%</span
                        >
                        <span class="fw-500 percentage" v-else>0%</span>
                      </CCol>
                      <CCol>
                        <span class="title col-black fw-500">Site Code</span>
                        <span class="col-black fw-500">Actual(Q)</span>
                        <span class="col-black fw-500">Actual(V)</span>
                      </CCol>
                      <CCol>
                        <span class="title">{{ siteRow.Plant_Code }}</span>
                        <span class="fw-500">{{
                          siteRow.Plant_Actual_Qty_Sum
                        }}</span>
                        <span class="fw-500">{{
                          siteRow.Plant_Actual_Revenue_Sum
                        }}</span>
                      </CCol>
                    </div>
                  </CCol>
                </CRow>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { CChartDoughnut } from "@coreui/vue-chartjs";
import { CChartBar } from "@coreui/vue-chartjs";
import axios from "axios";
export default {
  name: "Marketing_dashboard",
  components: { CChartDoughnut, CChartBar },
  data() {
    return {
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label: "col-3", input: "col-9" },
      currentdate: "",
      lastdate: "",
      clientvise_fromdate_value: "",
      sitevise_fromdate_value: "",
      sitevise_todate_value: "",
      siteOptions_client: [],
      clientOptions: [],
      siteOptions: [],
      siteArr: [],
      client_siteArr: [],
      options: [],
      client_chart_option: ["Budget", "Revenue"],
      Site_Code: [],
      Client_Site_Code: [],
      Plant_Name: "",
      Plant_Code: "",
      site_budget: 0,
      client_budget: 0,
      site_Received: 0,
      client_Received: 0,
      site_O_S_amount: 0,
      site_budget_revenue: 0,
      site_Received_revenue: 0,
      site_O_S_amount_revenue: 0,

      client_O_S_amount: 0,
      client_budget_revenue: 0,
      client_Received_revenue: 0,
      client_O_S_amount_revenue: 0,

      defaultDatasets_site: [{ backgroundColor: ["#DD1B16"], data: [0] }],
      defaultDatasets_site_revanue: [
        { backgroundColor: ["#DD1B16"], data: [0] },
      ],
      defaultDatasets_client: [{ backgroundColor: ["#DD1B16"], data: [0] }],
      defaultDatasets_client_revanue: [
        { backgroundColor: ["#DD1B16"], data: [0] },
      ],
      defaultDatasetsLine_site: [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ],
      defaultDatasetsLine_site_revenue: [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ],
      defaultDatasetsLine_client: [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ],
      defaultDatasetsLine_client_revenue: [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [0, 0, 0, 0],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ],
      site_list_data: [],
      client_list_data: [],
	  isLoading: false
    };
  },
  computed: {
    defaultDatasets() {
      return [
        {
          backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
          data: [40, 20, 10],
        },
      ];
    },
    defaultDatasetsLine() {
      return [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [30, 20, 12, 20],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [20, 40, 12, 39],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ];
    },
  },
  methods: {
    dateFilter_site() {
      //console.log('date filter');
      this.GetFilterData(this.Site_Code);
    },
    dateFilter_client() {
      //console.log('date filter');
      this.GetClientFilterData(this.Site_Code, this.Client_Code);
    },
    siteSel(value) {
      //console.log(value);

      var self = this;
      var selplant_codeArr = [];
      for (var a = 0; a < value.length; a++) {
        var selArr = self.siteArr.find(function (jsonitem, i) {
          //console.log(jsonitem.Plant_Name+' Sel:- '+value[a]);
          //console.log(jsonitem);
          if (jsonitem.Site_Name == value[a]) {
            //console.log(self.siteCode);
            //console.log(jsonitem.Customer_Name);
            //self.Plant_Name=jsonitem.Plant_Name;
            selplant_codeArr.push(jsonitem.Site_Code);
            //self.Site_Code=jsonitem.Site_Code;
            //self.Plant_Code=jsonitem.Plant_Code;
            //console.log(self.Site_Code);
          }
        });
      }
      self.Site_Code = [...new Set(selplant_codeArr)];
      //console.log(self.Site_Code);
      this.GetFilterData(self.Site_Code);
    },

    GetFilterData(Site_Code) {
      $("#loader").show();
      var self = this;
      var codejoin = Site_Code.join(",");
      //console.log(codejoin);
      var firstdate = $("#sitevise_fromdate").val();
      var today = $("#sitevise_todate").val();
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      //console.log(firstdate+' '+today);
      //console.log('callll');

      var requestInfo = {
        Plant_Code: codejoin,
        From_Date: firstdate,
        To_Date: today,
        Client_Code: "",
        Type: "plant",
        User_Id: Session_User_Id,
        Session_User_Id: Session_User_Id,
        Token: token,
      };
      //console.log(requestInfo);
      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "MarketingDashboard/GetPlantWiseBudgetForExecutive",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
	  this.isLoading = true;
      axios(config).then((result) => {
		  this.isLoading = false;
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          this.site_list_data = obj;
          //console.log(result);
          var Plant_Actual_Qty_Sum_total = 0;
          var Plant_Actual_Revenue_Sum_total = 0;
          var Plant_Budget_Qty_Sum_total = 0;
          var Plant_Budget_Revenue_Sum_total = 0;
          var Out_Standing_Amount_total = 0;

          var solid_budget_qty_total = 0;
          var solid_actual_qty_total = 0;
          var semi_solid_budget_qty_total = 0;
          var semi_solid_actual_qty_total = 0;
          var liquid_budget_qty_total = 0;
          var liquid_actual_qty_total = 0;
          var aquasqes_budget_qty_total = 0;
          var aquasqes_actual_qty_total = 0;

          var solid_budget_amt_total = 0;
          var solid_actual_amt_total = 0;
          var semi_solid_budget_amt_total = 0;
          var semi_solid_actual_amt_total = 0;
          var liquid_budget_amt_total = 0;
          var liquid_actual_amt_total = 0;
          var aquasqes_budget_amt_total = 0;
          var aquasqes_actual_amt_total = 0;

          var getData = obj.find(function (jsonitem, i) {
            Plant_Actual_Qty_Sum_total += parseFloat(
              jsonitem.Plant_Actual_Qty_Sum
            );
            Plant_Actual_Revenue_Sum_total += parseFloat(
              jsonitem.Plant_Actual_Revenue_Sum
            );
            Plant_Budget_Qty_Sum_total += parseFloat(
              jsonitem.Plant_Budget_Qty_Sum
            );
            Plant_Budget_Revenue_Sum_total += parseFloat(
              jsonitem.Plant_Budget_Revenue_Sum
            );
            Out_Standing_Amount_total += parseFloat(
              jsonitem.Out_Standing_Amount
            );

            if (jsonitem.Physical_Status == "SOLID") {
              solid_budget_qty_total = parseFloat(
                jsonitem.Plant_Budget_Qty_Sum
              );
              solid_actual_qty_total = parseFloat(
                jsonitem.Plant_Actual_Qty_Sum
              );

              solid_budget_amt_total += parseFloat(jsonitem.Budget_Revenue);
              solid_actual_amt_total += parseFloat(jsonitem.Actual_Revenue);
            } else if (jsonitem.Physical_Status == "SEMI SOLID") {
              semi_solid_budget_qty_total = parseFloat(
                jsonitem.Plant_Budget_Qty_Sum
              );
              semi_solid_actual_qty_total = parseFloat(
                jsonitem.Plant_Actual_Qty_Sum
              );

              semi_solid_budget_amt_total += parseFloat(
                jsonitem.Budget_Revenue
              );
              semi_solid_actual_amt_total += parseFloat(
                jsonitem.Actual_Revenue
              );
            } else if (jsonitem.Physical_Status == "LIQUID") {
              liquid_budget_qty_total = parseFloat(
                jsonitem.Plant_Budget_Qty_Sum
              );
              liquid_actual_qty_total = parseFloat(
                jsonitem.Plant_Actual_Qty_Sum
              );

              liquid_budget_amt_total += parseFloat(jsonitem.Budget_Revenue);
              liquid_actual_amt_total += parseFloat(jsonitem.Actual_Revenue);
            } else if (jsonitem.Physical_Status == "AQUEOUS") {
              aquasqes_budget_qty_total = parseFloat(
                jsonitem.Plant_Budget_Qty_Sum
              );
              aquasqes_actual_qty_total = parseFloat(
                jsonitem.Plant_Actual_Qty_Sum
              );

              aquasqes_budget_amt_total += parseFloat(jsonitem.Budget_Revenue);
              aquasqes_actual_amt_total += parseFloat(jsonitem.Actual_Revenue);
            }
          });
          //console.log(Plant_Actual_Qty_Sum_total);
          this.site_budget = Plant_Budget_Qty_Sum_total.toFixed(3);
          this.site_Received = Plant_Actual_Qty_Sum_total.toFixed(3);
          this.site_O_S_amount = Out_Standing_Amount_total.toFixed(3);

          this.client_budget_revenue =
            Plant_Budget_Revenue_Sum_total.toFixed(3);
          this.client_Received_revenue =
            Plant_Actual_Revenue_Sum_total.toFixed(3);
          this.client_O_S_amount_revenue = Out_Standing_Amount_total.toFixed(3);

          var pie_per = 0;
          if (this.site_Received != 0 && this.site_budget != 0) {
            pie_per = (this.site_Received / this.site_budget) * 100;
          }
          if (pie_per < 60) {
            //POOR
            this.defaultDatasets_site = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, 0, pie_per],
              },
            ];
          } else if (pie_per >= 60 && pie_per <= 90) {
            //AVERAGE
            this.defaultDatasets_site = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, pie_per, 0],
              },
            ];
          } else if (pie_per > 90) {
            //EXCELLANT
            this.defaultDatasets_site = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [pie_per, 0, 0],
              },
            ];
          }
          //var siteOptionsArr=obj;

          this.defaultDatasetsLine_site = [
            {
              label: "Budget",
              backgroundColor: "#03bd5b",
              data: [
                solid_budget_qty_total,
                semi_solid_budget_qty_total,
                liquid_budget_qty_total,
                aquasqes_budget_qty_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
            {
              label: "Actual",
              backgroundColor: "#f5a623",
              data: [
                solid_actual_qty_total,
                semi_solid_actual_qty_total,
                liquid_actual_qty_total,
                aquasqes_actual_qty_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
          ];

          var pie_per_revanue = 0;
          if (
            this.client_Received_revenue != 0 &&
            this.client_budget_revenue != 0
          ) {
            pie_per_revanue =
              (this.client_Received_revenue / this.client_budget_revenue) * 100;
          }
          if (pie_per_revanue < 60) {
            //POOR
            this.defaultDatasets_site_revanue = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, 0, pie_per_revanue],
              },
            ];
          } else if (pie_per_revanue >= 60 && pie_per_revanue <= 90) {
            //AVERAGE
            this.defaultDatasets_site_revanue = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, pie_per_revanue, 0],
              },
            ];
          } else if (pie_per_revanue > 90) {
            //EXCELLANT
            this.defaultDatasets_site_revanue = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [pie_per_revanue, 0, 0],
              },
            ];
          }

          this.defaultDatasetsLine_site_revenue = [
            {
              label: "Budget",
              backgroundColor: "#03bd5b",
              data: [
                solid_budget_amt_total,
                semi_solid_budget_amt_total,
                liquid_budget_amt_total,
                aquasqes_budget_amt_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
            {
              label: "Actual",
              backgroundColor: "#f5a623",
              data: [
                solid_actual_amt_total,
                semi_solid_actual_amt_total,
                liquid_actual_amt_total,
                aquasqes_actual_amt_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
          ];
          $("#loader").hide();
		this.isLoading = false;
        } else {
          $("#loader").hide();
		this.isLoading = false;
          this.site_list_data = [];
          this.site_budget = 0;
          this.site_Received = 0;
          this.site_O_S_amount = 0;
          this.defaultDatasets_site = [];
          this.defaultDatasetsLine_site = [];
          //$('#reponse_error').html(result.data.message);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      });
    },
    site_change_chart(value) {
      //console.log(value);
      if (value == "Budget") {
        $("#site_budget_pie").show();
        $("#site_budget_collumn").show();
        $("#site_revenue_pie").hide();
        $("#site_revenue_collumn").hide();
      } else {
        $("#site_revenue_pie").show();
        $("#site_revenue_collumn").show();
        $("#site_budget_pie").hide();
        $("#site_budget_collumn").hide();
      }
    },
    rowset_site: function (e) {
      var self = this;
      var budget_qty = e.currentTarget.getAttribute("budget_qty");
      var budget_revenue = e.currentTarget.getAttribute("budget_revenue");
      var actual_qty = e.currentTarget.getAttribute("actual_qty");
      var actual_revenue = e.currentTarget.getAttribute("actual_revenue");
      var out_standing_amount = e.currentTarget.getAttribute(
        "out_standing_amount"
      );
      var physical_status = e.currentTarget.getAttribute("physical_status");
      //console.log('calllll '+physical_status);
      var pie_per = 0;
      if (actual_qty != 0 && budget_qty != 0) {
        pie_per = (actual_qty / budget_qty) * 100;
      }
      self.site_budget = budget_qty;
      self.site_Received = actual_qty;
      self.site_O_S_amount = out_standing_amount;

      self.site_budget_revenue = budget_revenue;
      self.site_Received_revenue = actual_revenue;
      self.site_O_S_amount_revenue = out_standing_amount;

      //console.log(pie_per);
      if (pie_per < 60) {
        //POOR
        self.defaultDatasets_site = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, 0, pie_per],
          },
        ];
      } else if (pie_per >= 60 && pie_per <= 90) {
        //AVERAGE
        self.defaultDatasets_site = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, pie_per, 0],
          },
        ];
      } else if (pie_per > 90) {
        //EXCELLANT
        self.defaultDatasets_site = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [pie_per, 0, 0],
          },
        ];
      }
      var solid_budget_qty_total = 0;
      var solid_actual_qty_total = 0;
      var semi_solid_budget_qty_total = 0;
      var semi_solid_actual_qty_total = 0;
      var liquid_budget_qty_total = 0;
      var liquid_actual_qty_total = 0;
      var aquasqes_budget_qty_total = 0;
      var aquasqes_actual_qty_total = 0;

      var solid_budget_amt_total = 0;
      var solid_actual_amt_total = 0;
      var semi_solid_budget_amt_total = 0;
      var semi_solid_actual_amt_total = 0;
      var liquid_budget_amt_total = 0;
      var liquid_actual_amt_total = 0;
      var aquasqes_budget_amt_total = 0;
      var aquasqes_actual_amt_total = 0;

      if (physical_status == "SOLID") {
        solid_budget_qty_total = parseFloat(budget_qty);
        solid_actual_qty_total = parseFloat(actual_qty);

        solid_budget_amt_total += parseFloat(budget_revenue);
        solid_actual_amt_total += parseFloat(actual_revenue);
      } else if (physical_status == "SEMI SOLID") {
        semi_solid_budget_qty_total = parseFloat(budget_qty);
        semi_solid_actual_qty_total = parseFloat(actual_qty);

        semi_solid_budget_amt_total += parseFloat(budget_revenue);
        semi_solid_actual_amt_total += parseFloat(actual_revenue);
      } else if (physical_status == "LIQUID") {
        liquid_budget_qty_total = parseFloat(budget_qty);
        liquid_actual_qty_total = parseFloat(actual_qty);

        liquid_budget_amt_total += parseFloat(budget_revenue);
        liquid_actual_amt_total += parseFloat(actual_revenue);
      } else if (physical_status == "AQUEOUS") {
        aquasqes_budget_qty_total = parseFloat(budget_qty);
        aquasqes_actual_qty_total = parseFloat(actual_qty);

        aquasqes_budget_amt_total += parseFloat(budget_revenue);
        aquasqes_actual_amt_total += parseFloat(actual_revenue);
      }

      self.defaultDatasetsLine_site = [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [
            solid_budget_qty_total,
            semi_solid_budget_qty_total,
            liquid_budget_qty_total,
            aquasqes_budget_qty_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [
            solid_actual_qty_total,
            semi_solid_actual_qty_total,
            liquid_actual_qty_total,
            aquasqes_actual_qty_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ];

      var pie_per_revanue = 0;
      if (self.site_Received_revenue != 0 && self.site_budget_revenue != 0) {
        pie_per_revanue =
          (self.site_Received_revenue / self.site_budget_revenue) * 100;
      }
      if (pie_per_revanue < 60) {
        //POOR
        self.defaultDatasets_site_revanue = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, 0, pie_per_revanue],
          },
        ];
      } else if (pie_per_revanue >= 60 && pie_per_revanue <= 90) {
        //AVERAGE
        self.defaultDatasets_site_revanue = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, pie_per_revanue, 0],
          },
        ];
      } else if (pie_per_revanue > 90) {
        //EXCELLANT
        self.defaultDatasets_site_revanue = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [pie_per_revanue, 0, 0],
          },
        ];
      }

      self.defaultDatasetsLine_site_revenue = [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [
            solid_budget_amt_total,
            semi_solid_budget_amt_total,
            liquid_budget_amt_total,
            aquasqes_budget_amt_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [
            solid_actual_amt_total,
            semi_solid_actual_amt_total,
            liquid_actual_amt_total,
            aquasqes_actual_amt_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ];
    },
    siteClientSel(value) {
      //console.log(value);
      var self = this;
      var selplant_codeArr = [];
      for (var a = 0; a < value.length; a++) {
        var selArr = self.client_siteArr.find(function (jsonitem, i) {
          //console.log(jsonitem.Plant_Name+' Sel:- '+value[a]);
          //console.log(jsonitem);
          if (jsonitem.Site_Name == value[a]) {
            //console.log(self.siteCode);
            //console.log(jsonitem.Customer_Name);
            //self.Plant_Name=jsonitem.Plant_Name;
            selplant_codeArr.push(jsonitem.Site_Code);
            //self.Site_Code=jsonitem.Site_Code;
            //self.Plant_Code=jsonitem.Plant_Code;
            //console.log(self.Site_Code);
          }
        });
      }
      self.Client_Site_Code = [...new Set(selplant_codeArr)];
      //console.log(self.Client_Site_Code);
      this.GetClientFilterData(self.Client_Site_Code, self.Client_Code);
    },
    ClientSel(value) {
      //console.log(value);
      var self = this;
      var selplant_codeArr = [];
      for (var a = 0; a < value.length; a++) {
        var selArr = self.client_siteArr.find(function (jsonitem, i) {
          //console.log(jsonitem.Plant_Name+' Sel:- '+value[a]);
          //console.log(jsonitem);
          if (jsonitem.Client_Name == value[a]) {
            //console.log(self.siteCode);
            //console.log(jsonitem.Customer_Name);
            //self.Plant_Name=jsonitem.Plant_Name;
            selplant_codeArr.push(jsonitem.Client_Code);
            //self.Site_Code=jsonitem.Site_Code;
            //self.Plant_Code=jsonitem.Plant_Code;
            //console.log(self.Site_Code);
          }
        });
      }
      self.Client_Code = [...new Set(selplant_codeArr)];
      //console.log(self.Client_Code);
      this.GetClientFilterData(self.Client_Site_Code, self.Client_Code);
    },
    GetClientFilterData(Site_Code, Client_Code) {
	this.isLoading = true;
      $("#loader").show();
      var self = this;
      var codejoin = Site_Code.join(",");
      var clientjoin = Client_Code.join(",");
      //console.log(codejoin);
      var firstdate = $("#clientvise_fromdate").val();
      var today = $("#clientvise_todate").val();
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      //console.log(firstdate+' '+today);
      //console.log('callll');

      var requestInfo = {
        Plant_Code: codejoin,
        From_Date: firstdate,
        To_Date: today,
        Client_Code: clientjoin,
        Type: "Client",
        User_Id: Session_User_Id,
        Session_User_Id: Session_User_Id,
        Token: token,
      };
      //console.log(requestInfo);
      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "MarketingDashboard/GetClientWiseBudgetForExecutive",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config).then((result) => {
		  this.isLoading = false;
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          this.client_list_data = obj;
          //console.log(result);
          var Plant_Actual_Qty_Sum_total = 0;
          var Plant_Actual_Revenue_Sum_total = 0;
          var Plant_Budget_Qty_Sum_total = 0;
          var Plant_Budget_Revenue_Sum_total = 0;
          var Out_Standing_Amount_total = 0;

          var solid_budget_qty_total = 0;
          var solid_actual_qty_total = 0;
          var semi_solid_budget_qty_total = 0;
          var semi_solid_actual_qty_total = 0;
          var liquid_budget_qty_total = 0;
          var liquid_actual_qty_total = 0;
          var aquasqes_budget_qty_total = 0;
          var aquasqes_actual_qty_total = 0;

          var solid_budget_amt_total = 0;
          var solid_actual_amt_total = 0;
          var semi_solid_budget_amt_total = 0;
          var semi_solid_actual_amt_total = 0;
          var liquid_budget_amt_total = 0;
          var liquid_actual_amt_total = 0;
          var aquasqes_budget_amt_total = 0;
          var aquasqes_actual_amt_total = 0;

          var getData = obj.find(function (jsonitem, i) {
            Plant_Actual_Qty_Sum_total += parseFloat(jsonitem.Actual_Qty);
            Plant_Actual_Revenue_Sum_total += parseFloat(
              jsonitem.Actual_Revenue
            );
            Plant_Budget_Qty_Sum_total += parseFloat(jsonitem.Budget_Qty);
            Plant_Budget_Revenue_Sum_total += parseFloat(
              jsonitem.Budget_Revenue
            );
            Out_Standing_Amount_total += parseFloat(
              jsonitem.Out_Standing_Amount
            );

            if (jsonitem.Physical_Status == "SOLID") {
              solid_budget_qty_total += parseFloat(jsonitem.Budget_Qty);
              solid_actual_qty_total += parseFloat(jsonitem.Actual_Qty);

              solid_budget_amt_total += parseFloat(jsonitem.Budget_Revenue);
              solid_actual_amt_total += parseFloat(jsonitem.Actual_Revenue);
            } else if (jsonitem.Physical_Status == "SEMI SOLID") {
              semi_solid_budget_qty_total += parseFloat(jsonitem.Budget_Qty);
              semi_solid_actual_qty_total += parseFloat(jsonitem.Actual_Qty);

              semi_solid_budget_amt_total += parseFloat(
                jsonitem.Budget_Revenue
              );
              semi_solid_actual_amt_total += parseFloat(
                jsonitem.Actual_Revenue
              );
            } else if (jsonitem.Physical_Status == "LIQUID") {
              liquid_budget_qty_total += parseFloat(jsonitem.Budget_Qty);
              liquid_actual_qty_total += parseFloat(jsonitem.Actual_Qty);

              liquid_budget_amt_total += parseFloat(jsonitem.Budget_Revenue);
              liquid_actual_amt_total += parseFloat(jsonitem.Actual_Revenue);
            } else if (jsonitem.Physical_Status == "AQUEOUS") {
              aquasqes_budget_qty_total += parseFloat(jsonitem.Budget_Qty);
              aquasqes_actual_qty_total += parseFloat(jsonitem.Actual_Qty);

              aquasqes_budget_amt_total += parseFloat(jsonitem.Budget_Revenue);
              aquasqes_actual_amt_total += parseFloat(jsonitem.Actual_Revenue);
            }
          });
          //console.log(Plant_Actual_Qty_Sum_total);
          this.client_budget = Plant_Budget_Qty_Sum_total.toFixed(3);
          this.client_Received = Plant_Actual_Qty_Sum_total.toFixed(3);
          this.client_O_S_amount = Out_Standing_Amount_total.toFixed(3);

          this.client_budget_revenue =
            Plant_Budget_Revenue_Sum_total.toFixed(3);
          this.client_Received_revenue =
            Plant_Actual_Revenue_Sum_total.toFixed(3);
          this.client_O_S_amount_revenue = Out_Standing_Amount_total.toFixed(3);

          var pie_per = 0;
          if (this.client_Received != 0 && this.client_budget != 0) {
            pie_per = (this.client_Received / this.client_budget) * 100;
          }
          if (pie_per < 60) {
            //POOR
            this.defaultDatasets_client = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, 0, pie_per],
              },
            ];
          } else if (pie_per >= 60 && pie_per <= 90) {
            //AVERAGE
            this.defaultDatasets_client = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, pie_per, 0],
              },
            ];
          } else if (pie_per > 90) {
            //EXCELLANT
            this.defaultDatasets_client = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [pie_per, 0, 0],
              },
            ];
          }
          //var siteOptionsArr=obj;

          this.defaultDatasetsLine_client = [
            {
              label: "Budget",
              backgroundColor: "#03bd5b",
              data: [
                solid_budget_qty_total,
                semi_solid_budget_qty_total,
                liquid_budget_qty_total,
                aquasqes_budget_qty_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
            {
              label: "Actual",
              backgroundColor: "#f5a623",
              data: [
                solid_actual_qty_total,
                semi_solid_actual_qty_total,
                liquid_actual_qty_total,
                aquasqes_actual_qty_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
          ];

          var pie_per_revanue = 0;
          if (
            this.client_Received_revenue != 0 &&
            this.client_budget_revenue != 0
          ) {
            pie_per_revanue =
              (this.client_Received_revenue / this.client_budget_revenue) * 100;
          }
          if (pie_per_revanue < 60) {
            //POOR
            this.defaultDatasets_client_revanue = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, 0, pie_per_revanue],
              },
            ];
          } else if (pie_per_revanue >= 60 && pie_per_revanue <= 90) {
            //AVERAGE
            this.defaultDatasets_client_revanue = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [0, pie_per_revanue, 0],
              },
            ];
          } else if (pie_per_revanue > 90) {
            //EXCELLANT
            this.defaultDatasets_client_revanue = [
              {
                backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
                data: [pie_per_revanue, 0, 0],
              },
            ];
          }

          this.defaultDatasetsLine_client_revenue = [
            {
              label: "Budget",
              backgroundColor: "#03bd5b",
              data: [
                solid_budget_amt_total,
                semi_solid_budget_amt_total,
                liquid_budget_amt_total,
                aquasqes_budget_amt_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
            {
              label: "Actual",
              backgroundColor: "#f5a623",
              data: [
                solid_actual_amt_total,
                semi_solid_actual_amt_total,
                liquid_actual_amt_total,
                aquasqes_actual_amt_total,
              ],
              barThickness: 20,
              maxBarThickness: 14,
            },
          ];
          $("#loader").hide();
        } else {
          $("#loader").hide();
          this.client_list_data = [];
          this.client_budget = 0;
          this.client_Received = 0;
          this.client_O_S_amount = 0;
          this.defaultDatasets_client = [];
          this.defaultDatasetsLine_client = [];
          //$('#reponse_error').html(result.data.message);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      });
    },
    client_change_chart(value) {
      //console.log(value);
      if (value == "Budget") {
        $("#client_budget_pie").show();
        $("#client_budget_collumn").show();
        $("#client_revenue_pie").hide();
        $("#client_revenue_collumn").hide();
      } else {
        $("#client_revenue_pie").show();
        $("#client_revenue_collumn").show();
        $("#client_budget_pie").hide();
        $("#client_budget_collumn").hide();
      }
    },
    client_piechart() {},
    client_collumnchart() {},
    rowset_client: function (e) {
      var self = this;
      var budget_qty = e.currentTarget.getAttribute("budget_qty");
      var budget_revenue = e.currentTarget.getAttribute("budget_revenue");
      var actual_qty = e.currentTarget.getAttribute("actual_qty");
      var actual_revenue = e.currentTarget.getAttribute("actual_revenue");
      var out_standing_amount = e.currentTarget.getAttribute(
        "out_standing_amount"
      );
      var physical_status = e.currentTarget.getAttribute("physical_status");
      //console.log('calllll '+physical_status);
      var pie_per = 0;
      if (actual_qty != 0 && budget_qty != 0) {
        pie_per = (actual_qty / budget_qty) * 100;
      }
      self.client_budget = budget_qty;
      self.client_Received = actual_qty;
      self.client_O_S_amount = out_standing_amount;

      self.client_budget_revenue = budget_revenue;
      self.client_Received_revenue = actual_revenue;
      self.client_O_S_amount_revenue = out_standing_amount;

      //console.log(pie_per);
      if (pie_per < 60) {
        //POOR
        self.defaultDatasets_client = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, 0, pie_per],
          },
        ];
      } else if (pie_per >= 60 && pie_per <= 90) {
        //AVERAGE
        self.defaultDatasets_client = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, pie_per, 0],
          },
        ];
      } else if (pie_per > 90) {
        //EXCELLANT
        self.defaultDatasets_client = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [pie_per, 0, 0],
          },
        ];
      }
      var solid_budget_qty_total = 0;
      var solid_actual_qty_total = 0;
      var semi_solid_budget_qty_total = 0;
      var semi_solid_actual_qty_total = 0;
      var liquid_budget_qty_total = 0;
      var liquid_actual_qty_total = 0;
      var aquasqes_budget_qty_total = 0;
      var aquasqes_actual_qty_total = 0;

      var solid_budget_amt_total = 0;
      var solid_actual_amt_total = 0;
      var semi_solid_budget_amt_total = 0;
      var semi_solid_actual_amt_total = 0;
      var liquid_budget_amt_total = 0;
      var liquid_actual_amt_total = 0;
      var aquasqes_budget_amt_total = 0;
      var aquasqes_actual_amt_total = 0;

      if (physical_status == "SOLID") {
        solid_budget_qty_total = parseFloat(budget_qty);
        solid_actual_qty_total = parseFloat(actual_qty);

        solid_budget_amt_total += parseFloat(budget_revenue);
        solid_actual_amt_total += parseFloat(actual_revenue);
      } else if (physical_status == "SEMI SOLID") {
        semi_solid_budget_qty_total = parseFloat(budget_qty);
        semi_solid_actual_qty_total = parseFloat(actual_qty);

        semi_solid_budget_amt_total += parseFloat(budget_revenue);
        semi_solid_actual_amt_total += parseFloat(actual_revenue);
      } else if (physical_status == "LIQUID") {
        liquid_budget_qty_total = parseFloat(budget_qty);
        liquid_actual_qty_total = parseFloat(actual_qty);

        liquid_budget_amt_total += parseFloat(budget_revenue);
        liquid_actual_amt_total += parseFloat(actual_revenue);
      } else if (physical_status == "AQUEOUS") {
        aquasqes_budget_qty_total = parseFloat(budget_qty);
        aquasqes_actual_qty_total = parseFloat(actual_qty);

        aquasqes_budget_amt_total += parseFloat(budget_revenue);
        aquasqes_actual_amt_total += parseFloat(actual_revenue);
      }

      self.defaultDatasetsLine_client = [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [
            solid_budget_qty_total,
            semi_solid_budget_qty_total,
            liquid_budget_qty_total,
            aquasqes_budget_qty_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [
            solid_actual_qty_total,
            semi_solid_actual_qty_total,
            liquid_actual_qty_total,
            aquasqes_actual_qty_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ];

      var pie_per_revanue = 0;
      if (
        self.client_Received_revenue != 0 &&
        self.client_budget_revenue != 0
      ) {
        pie_per_revanue =
          (self.client_Received_revenue / self.client_budget_revenue) * 100;
      }
      if (pie_per_revanue < 60) {
        //POOR
        self.defaultDatasets_client_revanue = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, 0, pie_per_revanue],
          },
        ];
      } else if (pie_per_revanue >= 60 && pie_per_revanue <= 90) {
        //AVERAGE
        self.defaultDatasets_client_revanue = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [0, pie_per_revanue, 0],
          },
        ];
      } else if (pie_per_revanue > 90) {
        //EXCELLANT
        self.defaultDatasets_client_revanue = [
          {
            backgroundColor: ["#41B883", "#E46651", "#DD1B16"],
            data: [pie_per_revanue, 0, 0],
          },
        ];
      }

      self.defaultDatasetsLine_client_revenue = [
        {
          label: "Budget",
          backgroundColor: "#03bd5b",
          data: [
            solid_budget_amt_total,
            semi_solid_budget_amt_total,
            liquid_budget_amt_total,
            aquasqes_budget_amt_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
        {
          label: "Actual",
          backgroundColor: "#f5a623",
          data: [
            solid_actual_amt_total,
            semi_solid_actual_amt_total,
            liquid_actual_amt_total,
            aquasqes_actual_amt_total,
          ],
          barThickness: 20,
          maxBarThickness: 14,
        },
      ];
    },
  },
  mounted() {
    var self = this;
    var d = new Date();
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var today =
      d.getFullYear() +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day;
    //$('#sitevise_todate').val(today);
    self.sitevise_todate_value = today;
    //console.log(self.sitevise_todate_value);

    var firstdate =
      d.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + "01";
    self.sitevise_fromdate_value = firstdate;
    self.clientvise_fromdate_value = firstdate;

    //$('#sitevise_fromdate').val(firstdate);

    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
    $("#loader").show();
    var requestInfo = {
      Emp_Id: Session_User_Id,
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    //console.log(requestInfo);
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MarketingDashboard/GetBudgetDataList",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
	this.isLoading = true;
    axios(config).then((result) => {
		this.isLoading = false;
      if (result.data.status_code == 200) {
        var obj = result.data.response;
        //console.log(obj)
        var siteOptionsArr = obj;

        this.siteArr = obj;
        this.client_siteArr = obj;

        // localStorage.removeItem("site_list", JSON.stringify([]));
        // localStorage.setItem("site_list", JSON.stringify(siteOptionsArr));
        var siteSingleArr = [];
        var selplant_codeArr = [];

        var clientSingleArr = [];
        var selClient_CodeArr = [];
        var selArr = siteOptionsArr.find(function (jsonitem, i) {
          //console.log(jsonitem.Site_Name)
          siteSingleArr.push(jsonitem.Site_Name);
          selplant_codeArr.push(jsonitem.Site_Code);
          clientSingleArr.push(jsonitem.Client_Name);
          selClient_CodeArr.push(jsonitem.Client_Code);
        });
        this.siteOptions = [...new Set(siteSingleArr)];
        this.Site_Code = [...new Set(selplant_codeArr)];

        this.siteOptions_client = [...new Set(siteSingleArr)];
        this.Client_Site_Code = [...new Set(selplant_codeArr)];

        this.clientOptions = [...new Set(clientSingleArr)];
        this.Client_Code = [...new Set(selClient_CodeArr)];

        //console.log(this.Site_Code);
        this.GetClientFilterData(this.Site_Code, this.Client_Code);
        this.GetFilterData(this.Site_Code);
      } else {
		  this.isLoading = false;
        //$('#reponse_error').html(result.data.message);
        $("#loader").hide();
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.message,
        });
      }
    });
  },
};
</script>
